const loadGAScript = (callback: any, type: string) => {
  const existingScript = document.getElementById('googleAnalytic');
  if (!existingScript) {
    const script = document.createElement('script');
    let productPath = type === 'mltc' ? `/${type}` : type==='shieldstarter'?`/${type}`: '';
    if(type === "digitalsaver"){
      productPath = "/digitalsaver"
    }else if(type === "cancercover"){
      productPath = "/cancercover"
    }
    script.type = 'text/javascript';
    if (process.env.REACT_APP_ENVIRONMENT === "DEV"){
      script.type = 'text/typescript'; // This is to address the error screens on localhost

    }
    script.src = './adobe-script' + productPath;
    script.id = 'googleAnalytic';
    script.async = true;
    document.head.appendChild(script);
    script.onload = () => { 
      if (callback) callback();
    };
    console.debug('QnB ➤ GAScript ➤ ', { type });
  }
  if (existingScript && callback) callback();
};
export default loadGAScript;